// eslint-disable-next-line no-restricted-imports
import { isFedRamp, isIsolatedCloud } from '@atlassian/atl-context';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { fg } from '@confluence/feature-gating';

export const isContentTypeEnabledInCurrentEnv = (
	contentType: 'whiteboard' | 'database' | 'slide' | null | undefined,
): boolean => {
	if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
		if (fg('use_frontend_feature_encoding_sdk')) {
			const featureKeyMap: Record<string, string> = {
				database: 'confluence-databases',
				slide: 'confluence-slides',
				whiteboard: 'confluence-whiteboards',
			};
			const isEnabled = isFeatureEnabled('confluence', featureKeyMap[contentType]);

			if (isEnabled && isFedRamp()) {
				return fg('confluence_frontend_enable_canvas_types_in_fedramp');
			}

			if (isEnabled && isIsolatedCloud()) {
				return fg('confluence_frontend_enable_canvas_types_in_ic');
			}

			return isEnabled;
		}
		return !isFedRamp();
	}

	return true;
};
